import { Map } from 'immutable';

type State = Map<string, any>;
export const initialState: State = Map();

export default function reducer(state: State = initialState, action: any): State {
  switch (action.type) {
    case 'touch/TOUCH':
      return state.set(action.name, new Date());
    default:
      return state;
  }
}

type TouchAction = {
  type: 'touch/TOUCH';
  name: string;
};

export function touch(name: string): TouchAction {
  return {
    type: 'touch/TOUCH',
    name,
  };
}

export type TouchActions = TouchAction;
